import config from "./config.json";

export const cloudUrl = config.cloudUrl;
